import React from "react";
import { View } from "react-native";
import { useSearchParams } from "react-router-dom";
import HomeBeforeAfterV2 from "../before-after-v2/HomeBeforeAfterV2";
import { NormalText } from "../../../common/native";
import { MockScenarioKey } from "../before-after-v2/mock/mockMetadata";

const DEFAULT_SCENARIO: MockScenarioKey = "paired-balanced";

const BeforeAfterModalDebugPage: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  React.useEffect(() => {
    const nextParams = new URLSearchParams(searchParams.toString());
    let hasChanges = false;

    if (nextParams.get("test") !== "1") {
      nextParams.set("test", "1");
      hasChanges = true;
    }

    if (!nextParams.get("scenario")) {
      nextParams.set("scenario", DEFAULT_SCENARIO);
      hasChanges = true;
    }

    if (!hasChanges) return;
    setSearchParams(nextParams, { replace: true });
  }, [searchParams, setSearchParams]);

  return (
    <View style={{ flex: 1 }}>
      <View
        style={{
          marginHorizontal: 20,
          marginTop: 12,
          marginBottom: 6,
          paddingHorizontal: 10,
          paddingVertical: 8,
          borderRadius: 8,
          borderWidth: 1,
          borderColor: "#D0D5DD",
          backgroundColor: "#F8FAFC",
        }}
      >
        <NormalText
          text="Before/After Modal Debug runs full before-after flow in mock mode. Generate uses mock images and skips generation API calls."
          style={{ fontSize: 12, color: "#475467" }}
        />
      </View>

      <HomeBeforeAfterV2 />
    </View>
  );
};

export default BeforeAfterModalDebugPage;
